import React from 'react';
import { projects } from '../../content/site';
import styles from './Apps.module.css';

/** 터미널 목록으로 보여주는 작업과 서비스 */
export const Works: React.FC = () => (
    <div className={styles.works}>
        <p className={styles.command}><span className={styles.prompt}>dkdk:~$</span> ls works/</p>
        {projects.map(({ id, name, host, url }) => (url
            ? (
                <a key={id} className={styles.workRow} href={url}>
                    <span>{name}</span>
                    <span className={styles.workHost}>{host}</span>
                </a>
            )
            : (
                <p key={id} className={`${styles.workRow} ${styles.workRowLocked}`} style={{ margin: 0 }}>
                    <span>{name}</span>
                    <span>{host}</span>
                </p>
            )))}
        <p className={styles.cursor}><span className={styles.prompt}>dkdk:~$</span> _</p>
    </div>
);

export default Works;
